import React from 'react';
import constClass from '../../Constants/Constants';
import Common from '../Common/common';
// import moment from 'moment';

const TicketIssueList = ({ siteId, ticket_issuelist, ticketIssueClick, setting}) => {

  // const sysdate = new Date();
  // const sysdateTimestamp = sysdate.getTime();

  return (
    <div id="ticketList" className="ticket-issuelist">
      {ticket_issuelist && ticket_issuelist.map(ticket =>
        <div key={`${ticket.ticket_id}-${ticket.issue_count}`} className="ticket-box">
          <div className="frame39">
            <div className="ticket-name">{ticket.ticket_name}</div>
            {/* {ticket.ticket_summary && <div className="ticket-summary">{ticket.ticket_summary}</div>} */}
          </div>
          <div className="frame42">
            {ticket.ticket_image_url && <img className="ticket-image" src={`/${siteId}/${constClass.TICKET_IMAGE_DIR}${ticket.ticket_image_url}`} alt={ticket.ticket_name} />}
            {!ticket.ticket_image_url && <img className="ticket-image" src={`/${siteId}/noimage.png`} alt="noimage" />}
            <div className='frame41'>
              <div className="ticket-detail">{Common.getBrString(ticket.ticket_summary)}</div>
              <button
                onClick={() => ticketIssueClick(ticket.issue_count, ticket.ticket_id)}
                className="button text-black bg-lightwhite">
                クーポンを表示する
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TicketIssueList;